// TODO get from template
// TODO use backend reports.defaults._resource_order
// modules/django/dashboard/utils/__init__.py
export default [
  'electricity',
  'pv',
  'energy',
  'water',
  'gas',
  'fueloil', // not included in py
  'heating',
  'hot_water',
  'cooling',
  'geothermal',
  'wind',
  'co_gen',
  'solar_thermal',
  'compost',
  'recycling',
  'waste',
  'occupancy', // not included in py
  'percent_occupied', // not included in py
  'propane', // not included in py
  'all_resources', // not included in py
];
